import { ChevronRight } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { landingPageBackground, marketInsight3 } from '@assets/images';
import { useAppTranslation } from '@retail/app/i18n';
import { useAuthContext } from '@retail/auth/data-access';
import { PageLayout } from '@retail/components';
import { ContainedButton } from '@shared/components';

export const LandingPage = () => {
  const { login } = useAuthContext();
  const { t } = useAppTranslation();

  return (
    <PageLayout
      maxWidth="full"
      sx={{
        backgroundColor: (theme) => `${theme.vars.palette.background.paper} !important`,
      }}
    >
      <Grid
        container
        justifyContent={{ xs: 'end', lg: 'space-around' }}
        direction={{ xs: 'column', lg: 'row' }}
        minWidth={{ xs: '250px', lg: '500px' }}
        textAlign={{ xs: 'center', lg: 'left' }}
        flexGrow={1}
      >
        <Grid>
          <img
            src={landingPageBackground}
            style={{ position: 'absolute', bottom: 0, width: '100%', left: 0, right: 0 }}
            alt=""
          />
        </Grid>
        <Grid
          display="flex"
          flexDirection="column"
          justifyContent="center"
          pb={{ lg: 22 }}
          gap={4}
          alignItems={{ xs: 'center', lg: 'start' }}
          size={{
            lg: 5.3,
          }}
        >
          <Typography
            variant="h1"
            sx={(theme) => ({
              '& span': { color: 'primary.main' },
              ...theme.applyStyles('dark', { '& span': { color: 'primary.light' } }),
            })}
          >
            {t('app.welcomeTitle')} <span>{t('app.appName')}</span>
          </Typography>

          <ContainedButton onClick={() => login()} endIcon={<ChevronRight />}>
            {t('app.actions.logIn')}
          </ContainedButton>
        </Grid>

        <Grid
          display="flex"
          justifyContent="center"
          alignItems="end"
          size={{
            lg: 'auto',
          }}
        >
          <img src={marketInsight3} style={{ maxWidth: '636px' }} alt="" />
        </Grid>
      </Grid>
    </PageLayout>
  );
};
